module.exports = __webpack_public_path__ + "assets/instagram-list.8a80fbd6.svg";